exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-parent[data-v-22aa0900]{margin-top:20px;padding:20px;border:4px solid #eb2f96}.action[data-v-22aa0900]{margin-right:5px}", ""]);

// exports
